var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.checkIsExternal(_setup.props.to))?_c('a',{attrs:{"href":_setup.props.to,"target":"_blank","rel":"noopener"}},[_vm._t("default")],2):_c('router-link',{attrs:{"to":_setup.props.to}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }